import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

const baseQuery = fetchBaseQuery({
  baseUrl: process.env.NODE_ENV === 'production' ? '../../EntryPointService/api/EntryPoint' : '/api',
});

const api = createApi({
  reducerPath: 'api',
  baseQuery: async (args, api, extraOptions) => {
    let modifiedArgs = args;

    // Transform the request if NODE_ENV is 'local'
    if (process.env.NODE_ENV === 'local') {
      modifiedArgs = {
        ...args,
        body: {
          input: JSON.stringify(args.body),
        },
      };
    }
    
    const result = await baseQuery(modifiedArgs, api, extraOptions);

    // Transform the response if NODE_ENV is 'local'
    if (process.env.NODE_ENV === 'local' && result.data) {

      // @ts-ignore
      result.data = result.data.EntryPointJsonResult;
    }

    return result;
  },
  endpoints: (builder) => ({
  }),
});

export default api;